import React from 'react';
import { useTranslation } from 'react-i18next';
import { Eye, Users } from 'lucide-react';
import { UserSelectorAvatar } from '@/shared/components/user-selector/UserSelectorAvatar';
import type { FullIssueWithChildren } from '@/shared/utils/issue-guards';

interface ViewGoalViewersProps {
  viewers: FullIssueWithChildren['viewers'];
}

export const ViewGoalViewers: React.FC<ViewGoalViewersProps> = ({
  viewers,
}) => {
  const { t } = useTranslation('goals');

  const hasUsers = viewers?.users && viewers.users.length > 0;
  const hasTeams = viewers?.teams && viewers.teams.length > 0;

  if (!hasUsers && !hasTeams) return null;

  return (
    <div>
      <label className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-2 flex items-center gap-2">
        <Eye className="h-3.5 w-3.5" />
        {t('viewers')}
      </label>
      <div className="flex flex-wrap gap-2">
        {hasUsers &&
          viewers.users.map((viewer) => (
            <div
              key={viewer._id}
              className="flex items-center gap-2 px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg"
            >
              <UserSelectorAvatar
                fullName={`${viewer.personalInfo.firstName} ${viewer.personalInfo.lastName}`}
                imageUrl={viewer.personalInfo.imageUrl}
                size="sm"
              />
              <span className="text-sm text-gray-700">
                {viewer.personalInfo.firstName} {viewer.personalInfo.lastName}
              </span>
            </div>
          ))}
        {hasTeams &&
          viewers.teams.map((team) => (
            <div
              key={team._id}
              className="flex items-center gap-2 px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg"
            >
              <div className="flex items-center justify-center w-6 h-6 rounded-full bg-gray-100">
                <Users className="w-3.5 h-3.5 text-gray-600" />
              </div>
              <span className="text-sm text-gray-700">{team.name}</span>
            </div>
          ))}
      </div>
    </div>
  );
};
